export default function ButtonStyle({ enabled, style = {} }) {
  return {
    backgroundColor: `rgba(1, 31, 49, ${enabled ? 1 : 0.5})`,
    color: '#ffffff',
    cursor: enabled ? "pointer" : "none",
    fontFamily: "TradeGothicCondensed",
    fontSize: ".75rem",
    letterSpacing: ".2rem",
    padding: "1rem 2rem .8rem",
    textTransform: "uppercase",
    ...style
  };
}
